import { Component, OnDestroy, OnInit, inject } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import {
  DataContextBuilder,
  ElderSinglePaneWrapperComponent,
  ElderTableComponent,
  IDataContext,
  IsoDurationPipe,
  IsoIntervalPipe,
  Sort,
} from '@elderbyte/ngx-starter'
import { ActivatedRoute, Router } from '@angular/router'
import { Job, JobState } from '../job'
import { JobService } from '../job.service'
import { interval, Subject, takeUntil } from 'rxjs'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatIcon } from '@angular/material/icon'
import { DatePipe } from '@angular/common'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-job-browser',
  templateUrl: './job-browser.component.html',
  styleUrls: ['./job-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatProgressSpinner,
    MatSortHeader,
    DatePipe,
    ElderTranslatePipe,
    IsoDurationPipe,
    IsoIntervalPipe,
    ElderSinglePaneWrapperComponent,
  ],
})
export class JobBrowserComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private router = inject(Router)
  private route = inject(ActivatedRoute)
  public data: IDataContext<Job>
  private readonly unsubscribe$ = new Subject<void>()
  public readonly JobState = JobState

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const utopJobService = inject(JobService)
    this.data = DataContextBuilder.start<Job>().pageSize(10).activePaged().build(utopJobService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.data.start([new Sort('createdAt', 'desc')])

    interval(5000)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.log.info('Refreshing jobs...')
        if (this.data.isStarted) {
          this.data.reload()
        }
      })
  }

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openDetail(job: Job): void {
    this.log.info('clicked job: ', job.id)
    void this.router.navigate([job.id], { relativeTo: this.route })
  }
}
